export default function parse(flockml) {
  return new DOMParser()
    .parseFromString(`<flockml>${flockml}</flockml>`, 'text/html')
    .querySelector('flockml');
}
